import React from 'react';
import EpflLoader from '../helper/EpflLoader';


class SubmitSoftware extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            name:'',
            year:2020,
            credits:'',
            reference:'',
            openSource:'',
            useability:[],
            task:[],
            inputData:[],
            thumbnailName:'',
            thumbnail:'',
            isLoading:false,
            response:0,
            data:''
        }
        this.onChange.bind(this);
        this.uploadForm.bind(this);
        this.clearDB.bind(this);
    }

    onChange(e) {

        let files = e.target.files;
        let reader = new FileReader();

        reader.readAsDataURL(files[0]);
        //once data is loaded
        reader.onload= (e)=> { 
            this.setState({thumbnailName:files[0],
                thumbnail:e.target.result})

        }
    }

    uploadForm(){
        const data = new FormData()
        data.append('name',this.state.name)
        data.append('year',this.state.year)
        const fetchPath = "/api/submitSoftware"
        console.log(data)
        this.setState({isLoading:true,response:0})
        fetch(fetchPath,
        {
            method: 'post',
            headers: {
                "Accept": "application/text"
            },
            mode: 'same-origin',
            body: data
        }).then (response => {
            console.log(response)
            this.setState({isLoading:false})
            if (response.ok) {
                response.json().then(data => {
                    console.log(data)
                    this.setState({response:1,data:data})
                })
            } else {
                this.setState({response:-1})
            }
        })
    }
    // experimental code to communicate with python database
    clearDB(){
        const data = new FormData()
        const fetchPath = "/api/clearDB"
        this.setState({isLoading:true,response:0})
        fetch(fetchPath,
        {
            method: 'post',
            headers: {
                "Accept": "application/text"
            },
            mode: 'same-origin',
            body: data
        }).then (response => {
            console.log(response)
            this.setState({isLoading:false})
            if (response.ok) {
                response.json().then(data => {
                    console.log(data)
                    this.setState({response:1,data:data})
                })
            } else {
                this.setState({response:-1})
            }
        })
    }

    render () {
        //
        return (
            <div>
                <ul>
                    <li>SOFTWARE SUBMISSION NOT IMPLEMENTED</li>
                    <li>Add tags </li>
                    <li>Add all others software fields</li>
                    <li>Implement server routine to mail the form (need link to gmail or epfl mail)</li>
                    <li>Implement software display preview (table formated as in software list)</li>
                </ul>
                <div>
                    <h1> Software submission form</h1>
                    <label htmlFor="software_name" style={{marginTop:"10px"}}>Software name</label>
                    <input type="text" id="software_name" className="form-control" placeholder="Type here ..." onChange={() => {
                        this.setState({name:document.getElementById("software_name").value})
                    }}/>
                    <label htmlFor="software_year" style={{marginTop:"10px"}}>Year of last update</label>
                    <input type="text" id="software_year" className="form-control" placeholder="Type here ..." onChange={() => {
                        this.setState({year:parseFloat(document.getElementById("software_year").value)})
                    }}/>
                    <div className="upload" id="upload-input" style={{marginTop:"10px"}}>
                        <input type="file" name="upload-input-thumbnail" className="upload-input" id="upload-input-thumbnail" 
                        accept="image/x-png,image/gif,image/jpeg"
                        onChange={(e) => {
                            this.onChange(e)
                        }}/>
                        <label htmlFor="upload-input-thumbnail" className="btn btn-secondary btn-sm icon-right">
                            Software icon
                            <svg className="icon" aria-hidden="true">
                            <use xlinkHref="#icon-upload"></use>
                            </svg>
                        </label>
                        <div className="upload-preview" style={{fontSize:"16px",marginLeft:"5px"}}>
                            {this.state.thumbnailName.length > 0 ?
                                this.state.thumbnailName
                                : 'No file selected'
                            }
                        </div>
                    </div>
                </div>
                <br></br>
                <div align="center" style={{display:"flex"}}>
                    <span>
                        <h4>Software display preview</h4>
                         <p style={{display:"block",borderColor:"black",margin:"10px"}}>
                            {JSON.stringify(this.state, null, 2)}
                        </p>
                        
                    </span>
                    <div>
                        <img src={this.state.thumbnail} alt=""></img>
                    </div>
                </div>
                <br></br>
                <div align="center" style={{margin:"10px"}}>
                    <button className="btn btn-primary" onClick={()=>{
                        this.uploadForm()
                    }}>Submit software to server database</button>
                </div>
                <div align="center" style={{margin:"10px"}}>
                    <button className="btn btn-primary" onClick={()=>{
                        this.clearDB()
                    }}>Clear server database</button>
                </div>
                {this.state.isLoading === true && this.state.response === 0 &&
                    < EpflLoader/>}
                {this.state.isLoading === false && this.state.response === 1 &&
                <div>
                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                        The software submission has been performed successfully. It will be visible in the main software list after verification.
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
                }
                {this.state.isLoading === false && this.state.response === -1 &&
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <strong>Error !</strong> Something went wrong with the submission.
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>}
                </div>
            )
    }
}

export default SubmitSoftware;


/*
<form action={process.env.PUBLIC_URL + "/phpScripts/test-php-python.php"} method="post" target="hiddenFrame">
    
    Software Name:
    <input type="text" name="movie" maxLength="50"/>
    
    <input type="submit" name="submit" value="Submit"/>
</form>
*/